<template>
  <div class="radiobox fit-content d-inline-block">
    <div class="radiobox__wrapper">
      <label
        data-grid
        class="radiobox__label grid--va-center cursor-pointer"
      >
        <input
          type="radio"
          v-bind="{
            name, value, checked: isChecked
          }"
          @input.prevent="handleChange"
        >

        <span
          data-grid
          class="radiobox__radio grid--center grid--va-center"
        />

        <span class="radiobox__text">
          {{ label }}
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RadioBox',

  props: {
    label: {
      type: String,
      required: true
    },

    value: {
      type: [String, Number, Boolean],
      required: true
    },

    name: {
      type: String,
      default: () => ''
    },

    isChecked: Boolean
  },

  emits: ['input', 'update:modelValue'],

  methods: {
    handleChange (event) {
      const { value } = event.target

      this.$emit('input', value)
      this.$emit('update:modelValue', value)
    }
  }
})
</script>

<style lang="scss" scoped>
  .radiobox {
    --radius: 18px;

    &__label input {
      opacity: 0;
      visibility: hidden;
      width: 1px;
      height: 1px;
    }

    &__radio {
      --background: rgb(var(--gray15));
      --backgroundChecker: transparent;

      width: 18px;
      height: 18px;
      border-radius: var(--radius);
      background-color: var(--background);

      &:after {
        --width: 100%;
        --height: 100%;

        content: '';
        display: block;
        border-radius: inherit;

        width: var(--width);
        height: var(--height);
        background-color: var(--backgroundChecker);
      }

      :checked + & {
        --background: var(--primary);
        --backgroundChecker: rgb(var(--white));

        &:after {
          --width: 8px;
          --height: 8px;
          transition-delay: .1s;
        }
      }

      &,
      &:after {
        transition: all .2s ease-in-out;
      }
    }

    &__text {
      margin-inline: 8px 0;
      color: rgb(var(--gray1));
      letter-spacing: .05rem;
      font: 700 1.4rem / 1.8rem "Nunito", sans-serif;
    }
  }
</style>
